import { Modal, Form, Input, Button, message, Row, Col } from "antd";
import { getFirestore, collection, addDoc } from "firebase/firestore";

import {validateName,validatePhone} from "./validations";

export const Create = ({ isModalOpen, setIsModalOpen, update }) => {
    const [form] = Form.useForm();

  const db = getFirestore();

  // Create size in firebase
  const handleSubmit = async (values) => {
    await addDoc(collection(db, "couriers"), {
      ...values,
      status: true,
    })
      .then(() => {
        form.resetFields();
        update();
        message.success(`Courier ${values.name} fue creado`);
        setIsModalOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      title="Informacion de courier"
    >
      <Form
        name="createCourier"
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        autoComplete="off"
        requiredMark
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="name"
              label="Nombre"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar nombre",
                  type: "string",
                },
                {
                  validator: validateName,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="phone"
              label="Telefono"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar telefono",
                },
                {
                  validator: validatePhone,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="button-form footer-btn-modal create-form-btns">
          <Button onClick={() => setIsModalOpen(false)} size="large" className="btnCancel">
            Cancelar
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="button-right btnOK"
          >
            Crear
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
